define(['dataServicesBase', 'collectApi'], function (dataServicesBase, collectApi) {
  var clientVersion = collectApi.getVersion() || '0.0.0.0';
  var ins = new dataServicesBase.DataServices();

  ins.add('docer', 'http://wps.docer.wps.cn/v3.php/:_method_', {_method_: '@_method_'}, {
    user: { _method_: 'api/user', method: 'GET' }
  });

  ins.add('vip', '', {}, {
    // 外网
    payForRice: { url: 'https://vip.wps.cn/pay/daomi', method: 'POST' },
    checkPayStatus: { url: 'https://pay.wps.cn/api/order/order', method: 'GET' }

    // 内网
    //payForRice: { url: 'http://vip.wps.cn/pay/daomi', method: 'POST' },
    //checkPayStatus: { url: 'http://test.pay.wps.cn/api/order/order', method: 'GET' }
  });

  ins.add('easy/v3', 'https://easy.wps.cn/wppv3/:_method_', {_method_: '@_method_'}, {
    payForTemplate: { _method_: 'pc/pay/pay', method: 'POST', data: { protocolVersion: "1.0", appId: "wps_pc", clientVersion }, bJsonData: true },
    checkPayStatus: { _method_: 'pc/pay/paystatus', method: 'POST', data: { protocolVersion: "1.0", appId: "wps_pc", clientVersion }, bJsonData: true },
    fetchAlipayUrl: { _method_: 'pc/pay/alipay', method: 'POST', data: { protocolVersion: "1.0", appId: "wps_pc", clientVersion }, bJsonData: true },
    payRecord: { _method_: 'record/pay', method: 'POST', data: { protocolVersion: "1.0", appId: "wps_pc", clientVersion }, bJsonData: true },
    isBought: { _method_: 'user/isbuymb', method: 'POST', data: { protocolVersion: "1.0", appId: "wps_pc", clientVersion }, bJsonData: true }
  });

  ins.add('chartpay', 'http://www.docer.com/api/payment/chart/:_method_', {_method_: '@_method_'}, {
    payForTemplate: { _method_: 'pay', method: 'POST', bJsonData: true },
    checkPayStatus: { _method_: 'pay/check_pay_status', method: 'GET' },
    fetchAlipayUrl: { _method_: 'pay/alipay', method: 'GET' },
    fetchBuyIds:  { url: 'http://wps.docer.wps.cn/v3.php/api/chart/v1/my/buy_ids?mb_app=2', method: 'GET' }
  });

  return ins;
});



/** WEBPACK FOOTER **
 ** ./src/modules/unipay/scripts/service/dataServices.js
 **/